import * as THREE from 'three'
import gsap from 'gsap'
// import { OrbitControls } from 'three/addons/controls/OrbitControls.js'
import { RGBELoader } from 'three/addons/loaders/RGBELoader.js'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js'
import { mergeVertices } from 'three/addons/utils/BufferGeometryUtils.js'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
// import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js'
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js'
import CustomShaderMaterial from 'three-custom-shader-material/vanilla'
import wobbleVertexShader from './shaders/wobble/vertex.glsl'
import wobbleFragmentShader from './shaders/wobble/fragment.glsl'
import { MeshBasicMaterial } from 'three'
import { deltaTime } from 'three/tsl'
import { Raycaster } from 'three'


if (document.body.classList.contains('index-page')) {

}

/**
 * Base
 */

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Loaders
const loadingPlate = document.getElementById('loading-plate');
const loadingCircle = document.getElementById('loading-circle');

const loadingManager = new THREE.LoadingManager(
    // Loaded
    () =>
    {
        loadingPlate.style.opacity = '0'
        setTimeout(() => {
            loadingPlate.style.display = 'none';
        }, 1000)
    },
    (itemUrl, itemsLoaded, itemsTotal) =>
    {
        const progressRatio = itemsLoaded / itemsTotal
        const progressPI = progressRatio * 360
        console.log(progressPI)
        loadingCircle.style.background = `conic-gradient(from 0deg, #E2DBC5 0deg, #E2DBC5 ${progressPI}deg, transparent ${progressPI}deg)`
    }
)
const rgbeLoader = new RGBELoader(loadingManager)
const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('./draco/')
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)
const textureLoader = new THREE.TextureLoader(loadingManager)

/**
 * Environment map
 */
rgbeLoader.load('./background.hdr', (environmentMap) => //urban_alley_01_1k or background
{
    environmentMap.mapping = THREE.EquirectangularReflectionMapping

    // scene.background = environmentMap
    scene.environment = environmentMap
})

/******************************************
** Index Page
*******************************************/

if (document.body.classList.contains('index-page')) {


// Gradient Loader
const gradientTexture = textureLoader.load('textures/gradients/3.jpg')
gradientTexture.magFilter = THREE.NearestFilter

/**
 * Hydroflex Housing
 */

const objectsDistance = 4

let yPosition1st = window.innerWidth <= 768 ? 2 : 1.45;
let xPosition1st = window.innerWidth <= 768 ? 0.75 : 1.45;
let zPosition1st = window.innerWidth <= 768 ? -5 : 0;

let yPosition2nd = window.innerWidth <= 768 ? 1.4 : 2.2;
let xPosition2nd = window.innerWidth <= 768 ? 0.75 : -1.2;
let zPosition2nd = window.innerWidth <= 768 ? -5 : 4;

let hydroflexHousing;

gltfLoader.load('./Hydroflex-Housing.glb', (gltf) => 
{
    hydroflexHousing = gltf.scene
    hydroflexHousing.name = 'hydroflexHousing'; 
    hydroflexHousing.receiveShadow = true
    hydroflexHousing.castShadow = true

    hydroflexHousing.traverse((child) => {
        if (child.isMesh) {
            child.receiveShadow = true
            child.castShadow = true
        }
    })

    // hydroflexHousing.position.set(0, -0.75, 0) 
    // hydroflexHousing.rotation.set(0, Math.PI * -1.5, 0)
    hydroflexHousing.position.y = - objectsDistance * yPosition1st
    hydroflexHousing.position.x = xPosition1st
    hydroflexHousing.position.z = zPosition1st
    hydroflexHousing.rotation.y = Math.PI * 1.5
    hydroflexHousing.rotation.x = Math.PI * 0.08
    scene.add(hydroflexHousing)
})

/**
 * Wobble
 */
const uniforms = {
    uTime: new THREE.Uniform(0),
    uPositionFrequency: new THREE.Uniform(0.5),
    uTimeFrequency: new THREE.Uniform(0.4),
    uStrength: new THREE.Uniform(0.3)
}


// Material
const material = new CustomShaderMaterial({
    // CSM
    baseMaterial: THREE.MeshPhysicalMaterial,
    vertexShader: wobbleVertexShader,
    fragmentShader: wobbleFragmentShader,
    uniforms: uniforms,

    // MeshPhysicalMaterial
    metalness: 0,
    roughness: 0,
    color: '#e7e3d5',
    transmission: 1,
    ior: 1.5,
    thickness: 0.353,
    transparent: true,
    wireframe: false
})


// Aquacam Texture
const blueNoiseMaterial = new THREE.MeshBasicMaterial({
    color: '#7E9790'
})

const depthMaterial = new CustomShaderMaterial({
    // CSM
    baseMaterial: THREE.MeshDepthMaterial,
    vertexShader: wobbleVertexShader,

    // MeshDepthMaterial
    depthPacking: THREE.RGBADepthPacking

})


// Geometry
let geometry = new THREE.IcosahedronGeometry(2.5, 50)
geometry = mergeVertices(geometry)
geometry.computeTangents()
geometry.scale(.5, .5, .5)

// Mesh
const wobble = new THREE.Mesh(geometry, material)
wobble.customDepthMaterial = depthMaterial
wobble.receiveShadow = true
wobble.castShadow = true
wobble.position.set(0, 0, 0)
scene.add(wobble)

/**
 * Aquacam Logo
 */

let aquacamWidth = Math.floor(window.innerWidth * 0.005)
let aquacamLogo;
let aquacamLogoPath = window.innerWidth <= 768
    ? './aquacam-logo-mobile.glb'
    : './aquacam-logo.glb';

gltfLoader.load(aquacamLogoPath, (gltf) => 
{
    aquacamLogo = gltf.scene;
    aquacamLogo.name = 'aquacamLogo'; 
    aquacamLogo.receiveShadow = true;
    aquacamLogo.castShadow = true;

    window.innerWidth <= 768 
    ? aquacamLogo.scale.set(window.innerWidth * 0.007, window.innerWidth * 0.007, window.innerWidth * 0.007)
    : aquacamLogo.scale.set(aquacamWidth, aquacamWidth, aquacamWidth);

    window.innerWidth <= 768 
    ? aquacamLogo.position.set(-0.15, 0, 0) // Mobile
    : aquacamLogo.position.set(0, -0.75, 0);// Desktop
    aquacamLogo.rotation.set(0, Math.PI * 1.5, 0);

    scene.add(aquacamLogo);

    aquacamLogo.traverse((child) => {
        if (child.isMesh) {
            child.material = blueNoiseMaterial.clone();
            child.receiveShadow = true;
            child.castShadow = true;
        }
    });
});

/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 3)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.normalBias = 0.05
directionalLight.position.set(0.25, 2, - 2.25)
scene.add(directionalLight)

/**
 * Sizes
 */

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: Math.min(window.devicePixelRatio, 2)
}


window.addEventListener('resize', () =>
{
    // Update width
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    sizes.pixelRatio = Math.min(window.devicePixelRatio, 2)

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(sizes.pixelRatio)

    aquacamWidth = Math.floor(window.innerWidth * 0.005)
    aquacamLogo.scale.set(aquacamWidth, aquacamWidth, aquacamWidth)
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0, 0, 8) // 10, - 3, - 5
scene.add(camera)

// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = false

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    // alpha: true, 
    stencil: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.toneMappingExposure = 1
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor(0xa99c7e, 1) // really close a99c7e

/**
 * Post Processing
 */
const effectComposer = new EffectComposer(renderer)
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2)),
effectComposer.setSize(sizes.width, sizes.height)

const renderPass = new RenderPass(scene, camera)
effectComposer.addPass(renderPass)

// const rgbShiftPass = new ShaderPass(RGBShiftShader)
// effectComposer.addPass(rgbShiftPass)

// Grain/Noise shader
const GrainShader = {
    uniforms: {
        tDiffuse: { value: null },
        amount: { value: 0.1 }, // Adjust for more/less grain
        time: { value: 0 }
    },
    vertexShader: `
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
        }
    `,
    fragmentShader: `
        uniform sampler2D tDiffuse;
        uniform float amount;
        uniform float time;
        varying vec2 vUv;
        float rand(vec2 co){
            return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453 + time);
        }
        void main() {
            vec4 color = texture2D(tDiffuse, vUv);
            float grain = rand(vUv + time) * amount;
            gl_FragColor = vec4(color.rgb + grain, color.a);
        }
    `
};

const grainPass = new ShaderPass(GrainShader);
effectComposer.addPass(grainPass);

const gammaCorrectionShader = new ShaderPass(GammaCorrectionShader)
effectComposer.addPass(gammaCorrectionShader)

/**
 * Scroll
 */

let scrollY = window.scrollY
let currentSection = 0

window.addEventListener('scroll', () =>
{
    scrollY = window.scrollY
    const newSection = Math.round(scrollY / sizes.height)

    if(newSection != currentSection)
    {
        currentSection = newSection
        
        if(currentSection === 1 ) {

            

            gsap.to(
                hydroflexHousing.position,
                {
                    duration: 1.5,
                    ease: 'power2.inOut',
                    x: xPosition1st,
                    y: -objectsDistance * yPosition1st,
                    z: zPosition1st
                }
            )
        } else {
            gsap.to(
                hydroflexHousing.position,
                {
                    duration: 1.5,
                    ease: 'power2.inOut',
                    x: xPosition2nd,
                    y: -objectsDistance * yPosition2nd,
                    z: zPosition2nd
                }
            )
        }

    }
})

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Animate Camera
    camera.position.y = - scrollY / sizes.height * objectsDistance

    // Materials
    uniforms.uTime.value = elapsedTime

    // Update controls
    // controls.update()

    // Animate Meshes

    if (hydroflexHousing) {
        hydroflexHousing.rotation.y += Math.sin(deltaTime) * 0.1
    }

    // Render
    // renderer.render(scene, camera)
    effectComposer.render()

    // renderMaskedLogo(); 

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

/******************************************
** Housing Page
*******************************************/

} else if (document.body.classList.contains('housing-page')) {
    // Gradient Loader
const gradientTexture = textureLoader.load('textures/gradients/3.jpg')
gradientTexture.magFilter = THREE.NearestFilter

let scrollY = window.scrollY

    window.addEventListener('scroll', () => {
        scrollY = window.scrollY
    })

/**
 * Housing Points of Interest
 */
const raycaster = new Raycaster()
const points = [
    {
        position: new THREE.Vector3(0, 1.4, 1.5),
        element: document.querySelector('.point-0')
    },
    {
        position: new THREE.Vector3(0, 1.5, 1),
        element: document.querySelector('.point-1')
    },
    {
        position: new THREE.Vector3(0, 1.5, .6),
        element: document.querySelector('.point-2')
    },
    {
        position: new THREE.Vector3(0, -0.1, .6),
        element: document.querySelector('.point-3')
    }
]

// Loop through all points and add click functionality
points.forEach((point, index) => {
    const pointButton = document.querySelector(`.point-${index}`);
    const pointText = document.querySelector(`.point-${index}-text`);

    if (pointButton && pointText) {
        pointButton.addEventListener('click', (event) => {
            console.log(`Point ${index} clicked`); // Add this line
            event.stopPropagation(); // Prevent event from bubbling up
            
            // Close all other point texts first
            points.forEach((otherPoint, otherIndex) => {
                if (otherIndex !== index) {
                    const otherPointText = document.querySelector(`.point-${otherIndex}-text .text`);
                    if (otherPointText) {
                        otherPointText.classList.remove('visible');
                    }
                }
            });
            
            // Toggle the clicked point's text visibility
            if (pointText.classList.contains('visible')) {
                pointText.classList.remove('visible');
            } else {
                pointText.classList.add('visible');
            }
        });
    }
});

// Add click event to document to hide all text when clicking elsewhere
document.addEventListener('click', (event) => {
    // Check if click is outside any point element OR inside arrow buttons
    const clickedInsidePoint = points.some((point, index) => {
        const pointButton = document.querySelector(`.point-${index}`);
        return pointButton && pointButton.contains(event.target);
    });
    
    // Check if click is on arrow buttons (don't close if clicking arrows)
    const clickedOnArrow = event.target.closest('.text-arrow-forward') || 
                          event.target.closest('.text-arrow-back');
    
    if (!clickedInsidePoint && !clickedOnArrow) {
        // Hide all point texts
        points.forEach((point, index) => {
            const pointText = document.querySelector(`.point-${index}-text`);
            if (pointText) {
                pointText.classList.remove('visible');
            }
        });
    }
});

const textContent = [
    {
        title: "Standard HydroFlex Dome Port",
        text: "This is the same as the domes HydroFlex had designed and fabricated for the Cousteau Society's 35mm underwater cameras and has been an industry standard for many years with hundreds of credits on major blockbuster films."
    },
    {
        title: "250mm Dome Port",
        text: "Using the 250mm dome port is an advantage because of the 250mm dome’s larger diameter, lenses do not need close focus as much to focus on the aerial image created by the dome port."
    },
    {
        title: "The Standard HydroFlex Flat Port",
        text: "This comes standard with the RAC housings. Used underwater for close ups with longer focal length lenses underwater, for above water shooting, “split level” or when a shot goes from underwater to above water shooting or above water to underwater."
    },
    {
        title: "The Large Flat Port for RAC",
        text: "With the proliferation of larger sensors and lenses with wider acceptance angles, the Large Flat Port may be necessary as an add-on."
    }
];

// Current text index
let currentTextIndex = 0;

// Function to update text content
function updateSlidingText(index) {
    const textContainer = document.querySelector('.point-0-text .text-container');
    if (textContainer) {
        textContainer.innerHTML = `
            <h3>${textContent[index].title}</h3>
            <p>${textContent[index].text}</p>
        `;
    }
}

// Initialize with first text
updateSlidingText(currentTextIndex);

// Add event listeners to arrow buttons ONLY in point-0-text
const arrowForward = document.querySelector('.point-0-text .text-arrow-forward');
const arrowBack = document.querySelector('.point-0-text .text-arrow-back');

if (arrowForward) {
    arrowForward.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevent closing the point
        // Move to next text (loop back to 0 if at end)
        currentTextIndex = (currentTextIndex + 1) % textContent.length;
        updateSlidingText(currentTextIndex);
    });
}

if (arrowBack) {
    arrowBack.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevent closing the point
        // Move to previous text (loop to end if at beginning)
        currentTextIndex = (currentTextIndex - 1 + textContent.length) % textContent.length;
        updateSlidingText(currentTextIndex);
    });
}

/**
 * Hydroflex Housing
 */

const objectsDistance = 4

// let mobileVdesktopZ = window.innerWidth <= 768 ? -4.5 : 0;
// let mobileVdesktopY = window.innerWidth <= 768 ? 0.5 : 0;


let mobileVdesktopZ = window.innerWidth <= 768 ? 0 : 0;
let mobileVdesktopY = window.innerWidth <= 768 ? 0 : 0;


let hydroflexHousing;

gltfLoader.load('./Hydroflex-Housing.glb', (gltf) => 
{
    hydroflexHousing = gltf.scene
    hydroflexHousing.name = 'hydroflexHousing'; 
    hydroflexHousing.receiveShadow = true
    hydroflexHousing.castShadow = true

    hydroflexHousing.traverse((child) => {
        if (child.isMesh) {
            child.receiveShadow = true
            child.castShadow = true
        }
    })

    // hydroflexHousing.position.set(0, -0.75, 0) 
    // hydroflexHousing.rotation.set(0, Math.PI * -1.5, 0)
    hydroflexHousing.position.y = mobileVdesktopY
    hydroflexHousing.position.x = 0
    hydroflexHousing.position.z = mobileVdesktopZ
    hydroflexHousing.rotation.y = Math.PI * -3
    scene.add(hydroflexHousing)
})

/**
 * Wobble
 */
const uniforms = {
    uTime: new THREE.Uniform(0),
    uPositionFrequency: new THREE.Uniform(0.5),
    uTimeFrequency: new THREE.Uniform(0.4),
    uStrength: new THREE.Uniform(0.3)
}


// Material
const material = new CustomShaderMaterial({
    // CSM
    baseMaterial: THREE.MeshPhysicalMaterial,
    vertexShader: wobbleVertexShader,
    fragmentShader: wobbleFragmentShader,
    uniforms: uniforms,

    // MeshPhysicalMaterial
    metalness: 0,
    roughness: 0,
    color: '#e7e3d5',
    transmission: 1,
    ior: 1.5,
    thickness: 0.353,
    transparent: true,
    wireframe: false
})

// Tweaks
// gui.add(uniforms.uPositionFrequency, 'value', 0, 2, 0.001).name('uPositionFrequency')
// gui.add(uniforms.uTimeFrequency, 'value', 0, 2, 0.001).name('uTimeFrequency')
// gui.add(uniforms.uStrength, 'value', 0, 2, 0.001).name('uStrength')

// gui.add(material, 'metalness', 0, 1, 0.001)
// gui.add(material, 'roughness', 0, 1, 0.001)
// gui.add(material, 'transmission', 0, 1, 0.001)
// gui.add(material, 'ior', 0, 10, 0.001)
// gui.add(material, 'thickness', 0, 10, 0.001)
// gui.addColor(material, 'color')


/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 3)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.normalBias = 0.05
directionalLight.position.set(0.25, 2, - 2.25)
scene.add(directionalLight)

/**
 * Sizes
 */

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: Math.min(window.devicePixelRatio, 2)
}


window.addEventListener('resize', () =>
{
    // Update width
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    sizes.pixelRatio = Math.min(window.devicePixelRatio, 2)

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(sizes.pixelRatio)

    aquacamWidth = Math.floor(window.innerWidth * 0.005)
    aquacamLogo.scale.set(aquacamWidth, aquacamWidth, aquacamWidth)
})

/**
 * Camera
 */
// Base camera

let mobileVdesktopZCamera = window.innerWidth <= 768 ? 12 : 8;
// let mobileVdesktopY = window.innerWidth <= 768 ? 0 : 0;

const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0, 0, mobileVdesktopZCamera) // 10, - 3, - 5
scene.add(camera)

// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = false

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    // alpha: true, 
    stencil: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.toneMappingExposure = 1
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor(0xa99c7e, 1) // really close a99c7e

/**
 * Post Processing
 */
const effectComposer = new EffectComposer(renderer)
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2)),
effectComposer.setSize(sizes.width, sizes.height)

const renderPass = new RenderPass(scene, camera)
effectComposer.addPass(renderPass)

// const rgbShiftPass = new ShaderPass(RGBShiftShader)
// effectComposer.addPass(rgbShiftPass)

// Grain/Noise shader
const GrainShader = {
    uniforms: {
        tDiffuse: { value: null },
        amount: { value: 0.1 }, // Adjust for more/less grain
        time: { value: 0 }
    },
    vertexShader: `
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
        }
    `,
    fragmentShader: `
        uniform sampler2D tDiffuse;
        uniform float amount;
        uniform float time;
        varying vec2 vUv;
        float rand(vec2 co){
            return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453 + time);
        }
        void main() {
            vec4 color = texture2D(tDiffuse, vUv);
            float grain = rand(vUv + time) * amount;
            gl_FragColor = vec4(color.rgb + grain, color.a);
        }
    `
};

const grainPass = new ShaderPass(GrainShader);
effectComposer.addPass(grainPass);

const gammaCorrectionShader = new ShaderPass(GammaCorrectionShader)
effectComposer.addPass(gammaCorrectionShader)

/**
 * Scroll
 */

// let scrollY = window.scrollY
// let currentSection = 0

// window.addEventListener('scroll', () =>
// {
//     scrollY = window.scrollY
//     const newSection = Math.round(scrollY / sizes.height)

//     if(newSection != currentSection)
//     {
//         currentSection = newSection
        
//         if(currentSection === 1 ) {

            

//             gsap.to(
//                 hydroflexHousing.position,
//                 {
//                     duration: 1.5,
//                     ease: 'power2.inOut',
//                     x: xPosition1st,
//                     y: -objectsDistance * yPosition1st,
//                     z: zPosition1st
//                 }
//             )
//         } else {
//             gsap.to(
//                 hydroflexHousing.position,
//                 {
//                     duration: 1.5,
//                     ease: 'power2.inOut',
//                     x: xPosition2nd,
//                     y: -objectsDistance * yPosition2nd,
//                     z: zPosition2nd
//                 }
//             )
//         }

//     }
// })

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Materials
    uniforms.uTime.value = elapsedTime


    // Update controls
    // controls.update()

    // Animate Meshes

    if (hydroflexHousing) {
        // hydroflexHousing.rotation.y += Math.sin(deltaTime) * 0.1
        
        const radius = mobileVdesktopZCamera; // Distance from the housing
        const speed = 0.1; // Rotation speed (adjust as needed)
        
        camera.position.x = Math.cos(elapsedTime * speed) * radius;
        camera.position.z = Math.sin(elapsedTime * speed) * radius;
        camera.position.y = 0; // Keep camera at same height, or adjust as needed
        
        // Make camera always look at the housing
        camera.lookAt(hydroflexHousing.position);

        for(const point of points) {
            const screenPosition = point.position.clone()
            screenPosition.project(camera)

            raycaster.setFromCamera(screenPosition, camera)
            const intersects = raycaster.intersectObjects(scene.children, true)

            if(intersects.length === 0)
            {
                point.element.classList.add('visible')
            } else {
                point.element.classList.remove('visible')
            }

            const translateX = screenPosition.x * sizes.width * 0.5 
            const translateY = - screenPosition.y * sizes.height * 0.5 
            point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }
    } else {
           
    }

         // Animate Camera
    camera.position.y = - scrollY / sizes.height * objectsDistance

    // Render
    // renderer.render(scene, camera)
    effectComposer.render()

    // renderMaskedLogo(); 

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
}
